(function () {
    "use strict";

    angular
        .module('harriApp')
        .controller("WageMatrixBirthdateModalController", WageMatrixBirthdateModalController);

    WageMatrixBirthdateModalController.$inject = ["$scope", "modalData", "onSuccess", "onClose"];

    function WageMatrixBirthdateModalController ($scope, modalData, onSuccess, onClose) {
        const self = this;
        const SOURCES = {
            EMPLOYER_REVIEW: 'EMPLOYER_REVIEW',
            AUTOMATED_ONBOARDING_AMS: 'AUTOMATED_ONBOARDING_AMS',
        }

        let init = () => {
            self.brandId = modalData.brandId;
            self.prospectId = modalData.prospectId;
            self.source = modalData.source;
            self.birthDateRangeEndDate = moment().subtract(13, 'years').endOf('day');
        }

        init();

        self.close = () => {
            if (self.source === SOURCES.EMPLOYER_REVIEW) {
                hConfirm({
                    text: $filter("translate")("Closing this modal without filling the birthdate will block you from signing this document. Are you sure you want to continue") + '?',
                    confirmButton: $filter("translate")("Yes"),
                    cancelButton: $filter("translate")("Cancel"),
                    callback: (confirmed) => {
                        if (confirmed) {
                            onClose();
                            $scope.$hide();
                        }
                    }
                });
            } else if (self.source === SOURCES.AUTOMATED_ONBOARDING_AMS) {
                hConfirm({
                    title: $filter("translate")("Do not proceed"),
                    text: $filter("translate")("By choosing not to proceed with automation, this candidate will be excluded from the entire automation process. Do you still want to cancel?"),
                    confirmButton: $filter("translate")("Confirm"),
                    callback: (confirmed) => {
                        if (confirmed) {
                            onClose();
                            $scope.$hide();
                        }
                    },
                });
            } else {
                onClose();
                $scope.$hide();
            }
        };

        self.save = async () => {
            try {
                self.isSaving = true;
                const payload = {
                    birth_date: self.birth_date
                }
                const res = await UserAPI.updateUserDetails(self.brandId, self.prospectId, payload);
                onSuccess({birthdate: self.birth_date});
                $scope.$hide();
            } catch (err) {
                throw err;
            } finally {
                self.isSaving = false;
                $scope.$digest();
            }
        };
    }
})();